import React from "react"
import { Link } from "gatsby"
import { Button as RMWCButton } from "@rmwc/button"
import styled from "styled-components"
import classNames from "classnames"
import "@material/button/dist/mdc.button.css"
import "@material/ripple/dist/mdc.ripple.css"

const PADDING_DEFAULT = "1.2rem"
const PADDING_LARGE = "1.5rem"

const HEIGHT_DEFAULT = "45px"
const HEIGHT_LARGE = "55px"

const getSpacingSize = props =>
  props.size === "large" ? PADDING_LARGE : PADDING_DEFAULT

const getHeight = props =>
  props.size === "large" ? HEIGHT_LARGE : HEIGHT_DEFAULT

/**
 * These classes are applied to Gatsby Link to support it as an MDC button
 */
const mdcButtonClassNames = [
  "mdc-ripple-upgraded",
  "mdc-button",
  "mdc-button--unelevated",
]

const themeClassMap = {
  secondary: "mdc-theme--secondary",
  primary: "mdc-theme-primary",
}

const StyledButton = styled(({ useGatsbyLink, ...props }) => {
  return useGatsbyLink ? (
    <Link
      {...props}
      className={classNames(
        props.className,
        ...mdcButtonClassNames,
        themeClassMap[props.theme] || themeClassMap.primary
      )}
    >
      <div className="mdc-button__ripple"></div>
      {props.label}
    </Link>
  ) : (
    <RMWCButton {...props} unelevated />
  )
})`
  &.mdc-button {
    border-radius: 2rem;
    padding-left: ${getSpacingSize};
    padding-right: ${getSpacingSize};

    /* MDC Button uses height in pixels to determine button height */
    height: ${getHeight};

    text-transform: initial;
    font-size: var(--mdc-typography-body1-font-size);
    font-weight: 700;
    min-width: 179px;
  }

  &.mdc-theme--secondary {
    background-color: var(--mdc-theme-secondary);
  }
`

export function Button({ ...props }) {
  return <StyledButton {...props} />
}
